import { defineStore } from 'pinia'

export const useStatusStore = defineStore('statusStore', {
  state: (): SiteStatus => ({
    preloading: false,
    isChangePath: false,
  }),
  actions: {
    updatePreloading (preloading: boolean) {
      this.preloading = preloading
    },
    updateIsChangePath (isChangePath: boolean) {
      this.isChangePath = isChangePath
    },
  },
})
